import React from 'react';
import { TextField, Autocomplete, Tooltip, InputAdornment, IconButton } from '@mui/material';
import PhoneInput from 'react-phone-number-input';
import { PhoneInputCustom } from '../form/PhoneInputCustom';
import { CnpjMaskCustom, IEMaskCustom } from '../form/MaskedInputs';
import InfoIcon from '@mui/icons-material/Info';

export default function CompanyStep1Data({
  formData,
  handleUsernameBlur,
  handleInputChange,
  handleStateRegistrationChange,
  handlePhoneChange,
  errors,
  brazilianStates,
  currentUser
}) {
  return (
    <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 'var(--space-4)' }}>
      <h4 className="form-section-title" style={{ gridColumn: '1 / -1' }}>Dados da Empresa</h4>
      <TextField
        label="Slug (identificador)"
        name="slug"
        value={formData.slug || ''}
        onBlur={handleUsernameBlur}
        onChange={handleInputChange}
        required
        fullWidth
        error={!!errors.slug}
        helperText={errors.slug}
        disabled={currentUser?.role === 'ADMIN_CLIENT'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Este nome será usado em links e deve ser único, minúsculo e sem espaços. Ex: 'minha-empresa'.">
                <IconButton tabIndex={-1} type="button"><InfoIcon fontSize="small" /></IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }} />
      <TextField label="Razão Social" name="name" value={formData.name || ''} onChange={handleInputChange} fullWidth />
      <TextField
        label="CNPJ"
        name="cnpjOrTaxId"
        value={formData.cnpjOrTaxId || ''}
        onChange={handleInputChange}
        required
        fullWidth
        error={!!errors.cnpjOrTaxId}
        helperText={errors.cnpjOrTaxId}
        InputProps={{ inputComponent: CnpjMaskCustom }}
      />
      <Autocomplete
        options={brazilianStates}
        getOptionLabel={(option) => `${option.sigla} - ${option.nome}`}
        value={brazilianStates.find(s => s.sigla === formData.state) || null}
        onChange={(event, newValue) => {
          const fakeEvent = { target: { name: 'state', value: newValue ? newValue.sigla : '' } };
          handleInputChange(fakeEvent);
        }}
        isOptionEqualToValue={(option, value) => option.sigla === value.sigla}
        renderInput={(params) => (
          <TextField {...params} label="Estado (UF)" placeholder="Selecione o estado" />
        )}
      />
      <TextField
        label="Inscrição Estadual"
        name="stateRegistration"
        value={formData.stateRegistration || ''}
        onChange={handleStateRegistrationChange} fullWidth
        error={!!errors.ie}
        helperText={errors.ie}
        disabled={!formData.state}
        InputProps={{ inputComponent: IEMaskCustom, inputProps: { uf: formData.state } }}
      />
      <TextField label="Descrição" name="description" value={formData.description || ''} onChange={handleInputChange} fullWidth />
      <TextField label="Email de Contato" type="email" name="emailContact" value={formData.emailContact || ''} onChange={handleInputChange} required fullWidth />
      <PhoneInput
        value={formData.phone || ''}
        onChange={handlePhoneChange}
        defaultCountry="BR"
        displayInitialValueAsLocalNumber
        inputComponent={PhoneInputCustom}
      />
    </div>
  );
}